// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

import '@/styles/index.css' // global css

import store from './store';
import axios from 'axios'

import '@/utils/url-search-params.js';
import * as filters from './filters' // global filters

import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill()

Vue.prototype.$http = axios

Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper /* { default options with global component } */)

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.cfg = {
    apiDomain: process.env.VUE_APP_BASE_API,
    // imageDomain: process.env.VUE_APP_IMAGE_BASE_API
    imageDomain: process.env.VUE_APP_IMAGE_BASE_API
  }
} else {
  Vue.prototype.cfg = {
    apiDomain: `${window.location.protocol}//${window.location.host}`,
    imageDomain: process.env.VUE_APP_IMAGE_BASE_API
    // imageDomain: `${window.location.protocol}//${window.location.host}/`
  }
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
